import { Clarification } from '@/types/clarification';

export const formatClarificationDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const formatUserName = (
  user: Clarification['user'],
  currentUserId?: string
): string => {
  if (currentUserId && user.id === currentUserId) return 'You';
  return `${user.first_name} ${user.last_name}`;
};
